export default {
    install(app) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let elem = entry.target;
                    observer.unobserve(elem);
                    elem.onload = () => {
                        elem.style.opacity = 1;
                    };
                    elem.src = elem.dataset.src
                    // 图片加载出错时，显示默认图片
                    elem.onerror = () => {
                        // target.src = defaultImg
                    }
                }
            });
        }, {
            threshold: 0.01
        });
        app.directive('lazyload', {
            mounted: (el, bindings) => {
                // el - dom元素，bindings - 指令的值
                el.style.opacity = 0;
                el.style.transition = 'opacity .3s ease-in';
                el.dataset.src = bindings.value;
                // 监视 dom
                observer.observe(el);
            },
            updated: (el, bindings) => {
                if(bindings.value !== bindings.oldValue){
                    el.style.opacity = 0;
                    el.dataset.src = bindings.value;
                    observer.observe(el);
                }
            },
        });
    }
}
